

<template>
  <transition name="slide-up">
    <div id="NotificationWrapper" v-if="notifications.length > 0" class="animated">
      <div id="info"></div>
      <div v-for="notification in notifications" :key="notification.id" class="notification">
        <div class="textInfo">{{ notification.message }}</div>
        <button v-if="user" class="close-btn" @click="dismissNotification(notification.id)">✖</button>
      </div>
    </div>
  </transition>
  
</template>

<script>
  import { useAuthStore, fetchWithOrWithoutAuth, fetchWithAuth, refreshToken, startTokenRefreshTimer } from 'shared-vue'
  import { mapState } from 'pinia';
  export default {
    data() {
      return {
        notifications: [],
      };
    },
    computed: {
      ...mapState(useAuthStore, ['user']),
      isAdmin() {
        return this.user?.roles?.includes("Admin");
      }
    },
    async mounted() {
      await this.fetchNotifications();
      setInterval(() => this.fetchNotifications(), 60000); // 🔄 Poll every 1 min
    },
    methods: {
      async fetchNotifications() {
        try {
          const response = await fetchWithOrWithoutAuth("/notifications");
          if (response.ok) {
            this.notifications = await response.json();
          }
        } catch (error) {
          console.error("Error fetching notifications:", error);
        }
      },
      async dismissNotification(notificationId) {
        try {
          await fetchWithAuth(`/notifications/dismiss/${notificationId}`, { method: "POST" });
          this.notifications = this.notifications.filter(n => n.id !== notificationId);
        } catch (error) {
          console.error("Error dismissing notification:", error);
        }
      }
    }
  };
</script>

<style scoped>
  #NotificationWrapper {
    height: 3em;
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    z-index: 1000;
    background: #840b9dee;
  }
  /* Animate.css slide-up effect */
  .slide-up-enter-active {
    animation: slideInUp 0.5s ease-in;
  }

  .slide-up-leave-active {
    animation: slideOutDown 0.5s ease-out;
  }

  /*.notification {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: white;
    padding: 10px;
    border-radius: 5px;
    margin: 5px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  }

  .textInfo {
    color: black;
    font-size: 14px;
  }*/

  .close-btn {
    background: transparent;
    border: none;
    font-size: 16px;
    cursor: pointer;
    color: white;
    position: absolute;
    right: 8px;
    text-align: right;
    justify-content: right;
  }
</style>
